export default "__VITE_ASSET__CzRza0CS__"